var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecording(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00004 14.6673C4.31804 14.6673 1.33337 11.6827 1.33337 8.00065C1.33337 4.31865 4.31804 1.33398 8.00004 1.33398C11.682 1.33398 14.6667 4.31865 14.6667 8.00065C14.6667 11.6827 11.682 14.6673 8.00004 14.6673ZM8.00004 13.334C9.41453 13.334 10.7711 12.7721 11.7713 11.7719C12.7715 10.7717 13.3334 9.41514 13.3334 8.00065C13.3334 6.58616 12.7715 5.22961 11.7713 4.22941C10.7711 3.22922 9.41453 2.66732 8.00004 2.66732C6.58555 2.66732 5.229 3.22922 4.2288 4.22941C3.22861 5.22961 2.66671 6.58616 2.66671 8.00065C2.66671 9.41514 3.22861 10.7717 4.2288 11.7719C5.229 12.7721 6.58555 13.334 8.00004 13.334ZM8.00004 10.0007C7.46961 10.0007 6.9609 9.78994 6.58583 9.41487C6.21075 9.03979 6.00004 8.53108 6.00004 8.00065C6.00004 7.47022 6.21075 6.96151 6.58583 6.58644C6.9609 6.21136 7.46961 6.00065 8.00004 6.00065C8.53047 6.00065 9.03918 6.21136 9.41426 6.58644C9.78933 6.96151 10 7.47022 10 8.00065C10 8.53108 9.78933 9.03979 9.41426 9.41487C9.03918 9.78994 8.53047 10.0007 8.00004 10.0007Z",
    fill: "#30307D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecording);
export default __webpack_public_path__ + "static/media/recording.8541124b3178b906568d816eefa89cea.svg";
export { ForwardRef as ReactComponent };